import { ENABLE_APM_LOGS, FLO_MERCHANT_ID, FLO_USER_ID } from "lib/utils/constants";

export const initializeLogWrappers = () => {
  const merchantId = sessionStorage.getItem(FLO_MERCHANT_ID);
  const userId = sessionStorage.getItem(FLO_USER_ID);
  (window as any).newrelic?.wrapLogger(console, "error", {
    level: "error",
    customAttributes: {
      merchantId,
      userId,
    },
  });
  sessionStorage.setItem(ENABLE_APM_LOGS, "true");
};

/**
 * Converts an argument to a string representation
 */
const argToString = (arg: any): string => {
  if (arg === null) return "null";
  if (arg === undefined) return "undefined";
  if (typeof arg === "string") return arg;
  if (typeof arg === "number" || typeof arg === "boolean") return String(arg);
  if (arg instanceof Error) {
    return `Error: ${arg.message}${arg.stack ? `\n${arg.stack}` : ""}`;
  }
  try {
    return JSON.stringify(arg, null, 2);
  } catch (e) {
    return String(arg);
  }
};

/**
 * Combines multiple arguments into a single string for APM logging
 */
const combineArgs = (...args: any[]): string => {
  const merchantId = sessionStorage.getItem(FLO_MERCHANT_ID);
  const userId = sessionStorage.getItem(FLO_USER_ID);
  return [...args, { merchantId, userId }].map(argToString).join(" ");
};

/**
 * Log info message as a single string for APM tools
 */
export const logInfo = (...args: any[]): void => {
  const enableLogs = sessionStorage.getItem(ENABLE_APM_LOGS);
  if (enableLogs !== "true") return;
  (window as any).newrelic?.log(combineArgs(...args), { level: "info" });
};

/**
 * Log error message as a single string for APM tools
 */
export const logError = (...args: any[]): void => {
  const enableLogs = sessionStorage.getItem(ENABLE_APM_LOGS);
  if (enableLogs !== "true") return;
  (window as any).newrelic?.log(combineArgs(...args), { level: "error" });
};
